export const FUND_TARGET_ITEM_TEXT = {
  major: '주목적',
  notAvailable: 'N/A',
} as const;
